import PropTypes from 'prop-types';
import { Component } from 'react';
import { createPortal } from 'react-dom';

/**
 * The modalRoot is the element in the DOM where all modals are mounted. By mounting them at a
 * separate root from the rest of the app, it's becomes possible to force modals to be above the
 * z-index of everything else in the app.
 */
let modalRoot;
export const ensureModalRootIsInDOM = () => {
  if (modalRoot) {
    return;
  }
  modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', 'modal-root');
  modalRoot.style.position = 'absolute';
  modalRoot.style.top = 0;
  modalRoot.style.left = 0;
  modalRoot.style.zIndex = 2;
  document.body.appendChild(modalRoot);
};

class ModalRoot extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidMount = () => {
    ensureModalRootIsInDOM();
    modalRoot.appendChild(this.element);
  };

  componentWillUnmount = () => {
    ensureModalRootIsInDOM();
    modalRoot.removeChild(this.element);
  };

  element = document.createElement('div');

  render = () => createPortal(this.props.children, this.element);
}

export default ModalRoot;
